// extracted by mini-css-extract-plugin
module.exports = {"supportPolicy":"OldSupportPolicy_supportPolicy__aI264"};